export default __webpack_public_path__ + "static/media/organophone.e7b3f87f.PNG";